import { getModsetBase } from "../utils";
import { getAccessToken } from "./authService";
import {
  RecordsSearchFilterResponse,
  RecordsSearchFilterRequest,
} from "../types";
import { getDepartmentSpecificHeaders } from "../pages/LandingPage/helpers";

export const DEFAULT_SEARCH_FILTER_RESPONSE: RecordsSearchFilterResponse = {
  message: "Something went wrong",
  data: [],
};

export async function readRecordsBySearchFilter(
  request: RecordsSearchFilterRequest,
): Promise<RecordsSearchFilterResponse> {
  return request.httpMethod === "GET"
    ? readRecordsBySearchFilterGet(request)
    : readRecordsBySearchFilterPost(request);
}

export function readRecordsBySearchFilterPost(
  request: RecordsSearchFilterRequest,
): Promise<RecordsSearchFilterResponse> {
  const MODSET_URL = getModsetBase(request.functionalArea, request.url);

  const url = `${MODSET_URL}${request.url}`;

  const storeId = request.existingStoreIdValue ?? request.storeId;
  const groupId = request.existingGroupIdValue ?? request.groupId;

  return fetch(url, {
    method: "POST",
    headers: {
      "x-store-id": storeId,
      "x-enterprise-id": request.enterpriseId,
      "x-department": request.accountName,
      ...getDepartmentSpecificHeaders({
        groupId,
        departmentId: request.departmentId,
        functionalArea: request.functionalArea,
      }),
      REMOTE_USER: "sys-user-dms-admin",
      source: "ANY",
      "Content-Type": "application/json",
      Authorization: `Bearer ${getAccessToken()}`,
    },
    body: JSON.stringify(request.body),
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(error);
      return DEFAULT_SEARCH_FILTER_RESPONSE;
    });
}

export function readRecordsBySearchFilterGet(
  request: RecordsSearchFilterRequest,
): Promise<RecordsSearchFilterResponse> {
  const MODSET_URL = getModsetBase(request.functionalArea, request.url);

  const url = `${MODSET_URL}${request.url}`;

  const storeId = request.existingStoreIdValue ?? request.storeId;
  const groupId = request.existingGroupIdValue ?? request.groupId;

  return fetch(url, {
    method: "GET",
    headers: {
      "x-store-id": storeId,
      "x-enterprise-id": request.enterpriseId,
      "x-department": request.accountName,
      ...getDepartmentSpecificHeaders({
        groupId,
        departmentId: request.departmentId,
        functionalArea: request.functionalArea,
      }),
      REMOTE_USER: "sys-user-dms-admin",
      source: "ANY",
      Authorization: `Bearer ${getAccessToken()}`,
    },
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(error);
      return DEFAULT_SEARCH_FILTER_RESPONSE;
    });
}
